export type VideoStatus = "uploading" | "queued" | "processing" | "transcribing" | "ready" | "error"

export const VIDEO_STATUS_LABELS: Record<VideoStatus, string> = {
  uploading: "Subiendo",
  queued: "Pendiente",
  processing: "Procesando",
  transcribing: "Transcribiendo",
  ready: "Listo",
  error: "Error",
}
